// Model.jsx
import React, {useEffect, useRef, useState} from 'react';
import {useNavigate} from "react-router-dom";
import Swal from "sweetalert2";
import survey from "../Api/survey";
import {Field, Form, Formik, useFormik} from "formik";
import surveySubmit from "../Api/surveySubmit";

const ModelLaunch = ({ onClose }) => {
    const modalRef = useRef(null);
    const navigate = useNavigate();
    const [surveyData, setSurveyData] = useState(null);
    const [comment, setComment] = useState('');
    const handleOutsideClick = (e) => {
        if (modalRef.current && !modalRef.current.contains(e.target)) {
            onClose();
        }
    };

    useEffect(() => {
        document.body.style.overflow = 'hidden'; // Disable scrolling on the body when the modal is open
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.body.style.overflow = 'auto'; // Re-enable scrolling on the body when the modal is closed
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);

    const initialValues = {
        productId: "",
        comment: "",
    };

    const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })

    useEffect(() => {
        const fetchSurveyInfo = async () => {
            try {
                const response = await survey();
                setSurveyData(response.data.productDetail);
            } catch (error) {
                console.error("API Errors:", error.response.data.message);
                Toast.fire({
                    icon: 'error',
                    title: error.response.data.message
                })
                navigate("/starting");
                if (error.response.status === 401 || error.response.status === 500) {
                    Toast.fire({
                        icon: 'error',
                        title: error.response.data.title
                    })
                    localStorage.clear();
                    onClose()
                }
                Toast.fire({
                    icon: 'error',
                    title: error.response.data.message
                })
                onClose()
            }
        };

        fetchSurveyInfo();
    }, []);

    const formik = useFormik({
        initialValues,
        onSubmit: async (values) => {
            values.productId = surveyData?.productId;
            values.comment = comment;
            if (comment !== '') {
                try {
                    await surveySubmit(values);
                    onClose()
                    Toast.fire({
                        icon: 'success',
                        title: 'Submitted'
                    })
                } catch (error) {
                    Toast.fire({
                        icon: 'error',
                        title: error.message
                    })
                }
            }
        },
    });

    const currentDateTime = new Date();
    const year = currentDateTime.toLocaleString("default", { year: 'numeric' });
    const month = currentDateTime.toLocaleString("default", { month: 'numeric' });
    const day = currentDateTime.toLocaleString("default", { day: 'numeric' });
    const time = currentDateTime.toLocaleString("default", { hour: 'numeric', minute: 'numeric', hour12: true });
    const formattedDateTime = `${year}-${month}-${day} | ${time}`;

    return (
        <div>
            <div className="modal-overlay"></div>

            <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block' }}>
                <div className="modal-dialog modal-dialog-centered p-3 py-5" ref={modalRef}>
                    <div className="modal-content">
                        <div className="container d-flex flex-column p-4">
                            <div className="mt-5 mb-3 text-center">
                                <div className="survey-image mx-auto mb-4">
                                    <img src={surveyData?.productImage} alt='productImage' width={200}  />
                                </div>
                                <div className="fs-6 fw-bold text-pink">Brand</div>

                                <div className="fs-3 fw-bold text-white">{surveyData?.productName}</div>

                                <div className="d-flex justify-content-evenly mt-5">
                                    <div className=" d-flex flex-column">
                                        <span className="fs-6 fw-bold text-pink">App Value</span>
                                        <span className="fw-bold text-white fs-5">{surveyData?.productCurrency} {surveyData?.productPrice}</span>
                                    </div>
                                    <div className="divider-right"></div>
                                    <div className="text-white d-flex flex-column">
                                        <span className="fs-6 fw-bold text-pink">Earning</span>
                                        <span className="fw-bold text-white fs-5">{surveyData?.productCurrency} {surveyData?.earning}</span>
                                    </div>
                                </div>

                                <div className="d-flex justify-content-between mt-5 text-white">
                                    <span className="fs-6 fw-bold text-pink">Creation Time</span>
                                    <p className="fw-bold">{formattedDateTime.toUpperCase()}</p>
                                </div>

                                <div className="d-flex justify-content-between text-white">
                                    <span className="fs-6 fw-bold text-pink">Survey No</span>
                                    <p className="fw-bold">{surveyData?.surveyNo}</p>
                                </div>
                            </div>

                            <Formik
                                initialValues={initialValues}
                            >
                                <Form onSubmit={formik.handleSubmit}>
                                    <div className="survey-tickbox">
                                        <label className="mb-3 text-white">
                                            <Field
                                                type="radio"
                                                className="me-2"
                                                name="comment"
                                                value="Such a great apps with high quality and up to date"
                                                onInput={(event) => setComment(event.target.value)}
                                            />
                                            Such a great apps with high quality and up to date
                                        </label>
                                        <label className="mb-3 text-white">
                                            <Field
                                                type="radio"
                                                className="me-2"
                                                name="comment"
                                                value="Normal, haven't used it, just know it exits"
                                                onInput={(event) => setComment(event.target.value)}
                                            />
                                            Normal, haven't used it, just know it exits
                                        </label>
                                        <label className="mb-3 text-white">
                                            <Field
                                                type="radio"
                                                className="me-2"
                                                name="comment"
                                                value="Meh so far! Lots of bugs and getting worse"
                                                onInput={(event) => setComment(event.target.value)}
                                            />
                                            Meh so far! Lots of bugs and getting worse
                                        </label>
                                    </div>

                                    {formik.touched.comment && formik.errors.comment && (
                                        <div className='mt-2'>
                                            <span className='error'>{formik.errors.comment}</span>
                                        </div>
                                    )}

                                    <div className="d-flex mt-3 mb-4 justify-content-around">
                                        <button type="submit" className="starting-btn px-1 py-2 rounded-3 fs-5">Submit</button>
                                    </div>
                                </Form>
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModelLaunch;
